// extracted by mini-css-extract-plugin
export var item = "ItemList-module--item--e7de6";
export var itemList = "ItemList-module--itemList--43d4d";
export var list = "ItemList-module--list--e1d66";
export var title = "ItemList-module--title--f69be";